import { render, staticRenderFns } from "./GraficaNovedadesInspeccionesRelevancia.vue?vue&type=template&id=33bdb94e"
import script from "./GraficaNovedadesInspeccionesRelevancia.vue?vue&type=script&lang=js"
export * from "./GraficaNovedadesInspeccionesRelevancia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports